import React, {useState} from 'react';
import {InputNumber} from 'antd';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import DonutChart from '../../../../components/admin/reports/charts/DonutChart';
import KpiStatRow from '../../../../components/admin/reports/charts/KpiStatRow';

export default function ActivitySection({dateTo}) {
    const [activeWindowDays, setActiveWindowDays] = useState(90);
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_PATIENTS_ACTIVITY,
        params: {date_to: dateTo, active_window_days: activeWindowDays},
        dataDefault: {},
    });

    const donutData = [
        {label: 'Ativos', value: data?.active_patients ?? 0},
        {label: 'Inativos', value: data?.inactive_patients ?? 0},
    ];
    const hasData = (data?.total_patients ?? 0) > 0;

    return (
        <ReportChartCard
            title="Pacientes Ativos x Inativos"
            loading={isLoading}
            isEmpty={!hasData}
            extra={
                <InputNumber
                    size="small"
                    min={1}
                    addonBefore="Janela (dias)"
                    value={activeWindowDays}
                    onChange={(value) => setActiveWindowDays(value || 90)}
                    style={{width: 180}}
                />
            }
        >
            <DonutChart data={donutData} dataKey="value" nameKey="label"/>
            <div style={{marginTop: 16}}>
                <KpiStatRow
                    loading={isLoading}
                    items={[
                        {title: 'Total de Pacientes', value: data?.total_patients ?? 0},
                        {title: 'Ativos', value: data?.active_patients ?? 0},
                        {title: 'Inativos', value: data?.inactive_patients ?? 0},
                    ]}
                />
            </div>
        </ReportChartCard>
    );
}
